import React from "react";
import { useSelector } from "react-redux";
import { Container } from "react-bootstrap";
import HelmetWrapper from "../../HelmetWrapper";
import BCAScheduledBroadcastLogsStructure from "../../components/broadcast-system/bca-scheduler/BCAScheduledBroadcastLogsStructure";
import { selectUser } from "../../components/auth/auth.selector";

const BCAScheduledWatiLogs = () => {
  const userInfoData = useSelector(selectUser);

  return (
    <HelmetWrapper title="WTF: BCA Scheduled Broadcast Logs">
      <Container className="bg-cloud-k px-50px gobal-container" fluid>
        <BCAScheduledBroadcastLogsStructure userInfoData={userInfoData} />
      </Container>
    </HelmetWrapper>
  );
};

export default BCAScheduledWatiLogs;
